module.exports = __webpack_public_path__ + "img/XC.9167c547.png";